export default __webpack_public_path__ + "static/media/4f995a17770e976d79aba9fa90e73eff.svg";